import { App } from "vue";
import * as components from "../../components";
import * as bizComponents from "../../biz-components";

import componentPlugin from "@/views/report-center/component/report-icon/index";
import fileIconPlugin from "@/views/cloud-disk/component/cloud-file-icon/index";
import "@/components/svg-icon/require-icon";

export function setupGlobalComponents(app: App) {
  // components 目录下含有 isGlobal: true 参数的组件会被注册为全局组件
  Object.keys({...components,...bizComponents}).forEach((key) => {
    const cmpt = components[key]||bizComponents[key];
    if (cmpt?.isGlobal) {
      app.component(cmpt.name, cmpt);
    }
  });


  app.use(componentPlugin);
  app.use(fileIconPlugin);
}
